import "./Party.scss";
import { useMemo } from "react";

const COLORS = ["#67ff95", "#ffe14d", "#ff6fb5", "#6fd6ff", "#c08bff", "#ff9a5c"];

// Deterministic pseudo-random, so the confetti does not reshuffle on re-render.
function makeRandom(seed) {
  let state = seed;
  return () => {
    state = (state * 1664525 + 1013904223) % 4294967296;
    return state / 4294967296;
  };
}

function Party({ onFinish }) {
  const confetti = useMemo(() => {
    const rand = makeRandom(20260215);
    return Array.from({ length: 44 }, () => ({
      left: rand() * 100,
      delay: rand() * 3.2,
      duration: 2.8 + rand() * 2.6,
      drift: (rand() - 0.5) * 24,
      spin: 360 + rand() * 720,
      size: 0.7 + rand() * 0.9,
      color: COLORS[Math.floor(rand() * COLORS.length)],
      round: rand() > 0.72,
    }));
  }, []);

  const bursts = useMemo(() => {
    const rand = makeRandom(70707);
    return Array.from({ length: 4 }, (_, i) => ({
      left: 12 + rand() * 76,
      top: 10 + rand() * 45,
      delay: i * 0.9 + rand() * 0.4,
      color: COLORS[i % COLORS.length],
      sparks: Array.from({ length: 12 }, (_, s) => (s * 360) / 12),
    }));
  }, []);

  return (
    <div className="party">
      <div className="party__sky" aria-hidden="true">
        {bursts.map((burst, i) => (
          <span
            key={i}
            className="party__burst"
            style={{ left: `${burst.left}%`, top: `${burst.top}%`, animationDelay: `${burst.delay}s` }}
          >
            {burst.sparks.map((angle, s) => (
              <i
                key={s}
                style={{
                  "--angle": `${angle}deg`,
                  background: burst.color,
                  animationDelay: `${burst.delay}s`,
                }}
              />
            ))}
          </span>
        ))}
        {confetti.map((piece, i) => (
          <span
            key={i}
            className={`party__confetti${piece.round ? " party__confetti--round" : ""}`}
            style={{
              left: `${piece.left}%`,
              width: `${piece.size}vmin`,
              height: `${piece.size * 1.6}vmin`,
              background: piece.color,
              animationDelay: `${piece.delay}s`,
              animationDuration: `${piece.duration}s`,
              "--drift": `${piece.drift}vmin`,
              "--spin": `${piece.spin}deg`,
            }}
          />
        ))}
      </div>

      <div className="party__card">
        <h1 className="party__title">Felicitats!</h1>
        <p className="party__text">Has trobat totes les diferències.</p>
        <button className="restart-button" onClick={onFinish}>
          Tornar al jardí
        </button>
      </div>
    </div>
  );
}
export default Party;
